export default __webpack_public_path__ + "static/media/image1.3cf3babd.jpg";